import Saved from './Saved'

export default Saved
